import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import BlogPage from './pages/Blog';
import CareersPage from './pages/Careers';
import ContactPage from './pages/Contact';
import EstimatesPage from './pages/Estimates';
import GenspacePage from './pages/Genspace';
import HomePage from './pages/Home';
import LeasingPage from './pages/Leasing';
import LoginCallbackPage from './pages/LoginCallback'; // nowy import
import ManagementPage from './pages/Management';
import ProductsPage from './pages/Products';
import RootLayout from './pages/Root';
import TeamPage from './pages/Team';
import { MobileProvider } from './providers/MobileProvider';
import './style.css';

const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        children: [
            { path: '/', element: <HomePage /> },
            { path: '/products', element: <ProductsPage /> },
            { path: '/products/genspace', element: <GenspacePage /> },
            { path: '/products/budget-estimate', element: <EstimatesPage /> },
            { path: '/products/leasing', element: <LeasingPage /> },
            { path: '/products/management', element: <ManagementPage /> },
            { path: '/team', element: <TeamPage /> },
            { path: '/careers', element: <CareersPage /> },
            { path: '/contact', element: <ContactPage /> },
            { path: '/blog', element: <BlogPage /> },
            { path: '/login/callback', element: <LoginCallbackPage /> },
        ],
    },
]);

function oldSqarplanLinksRedirect() {
    const urlBase = process.env.REACT_APP_OLD_LINK_REDIRECTION_BASE;
    const url = window.location.href;
    const parts = url.split('/#/');

    // Redirection if old link (link which contains: "/#/" after domain)
    if (parts.length === 2 && parts[0] === window.location.origin) {
        const newUrl = urlBase + '/' + parts[1];
        window.location.href = newUrl;
    }
}

// Confer 2-char lang code to 5-char e.g. 'en' to 'en-EN'
function convertLanguageCodeTo5Char(code) {
    if (code.length !== 2) {
        return code;
    }
    return `${code}-${code.toUpperCase()}`;
}

function App() {
    oldSqarplanLinksRedirect();

    const { i18n } = useTranslation();

    useEffect(() => {
        const validLanguages = ['pl-PL', 'en-EN'];
        const storedLang = localStorage.getItem('i18nextLng');
        console.log({ validLanguages, storedLang });
        if (!validLanguages.includes(storedLang)) {
            let userDefaultLanguage = navigator.language || navigator.userLanguage;

            userDefaultLanguage = convertLanguageCodeTo5Char(userDefaultLanguage);

            if (!validLanguages.includes(userDefaultLanguage)) userDefaultLanguage = 'en-EN';

            console.log('Invalid language set as default - change to ', userDefaultLanguage);

            localStorage.setItem('i18nextLng', userDefaultLanguage);
            i18n.changeLanguage(userDefaultLanguage);
        }
    }, [i18n]);

    return (
        <MobileProvider>
            <RouterProvider router={router} />
        </MobileProvider>
    );
}

export default App;
